import React from "react";
import { useTranslation } from "react-i18next";

import img1 from "@/assets/explore-maatra/remote-family-img1.png";
import img2 from "@/assets/explore-maatra/remote-family-img2.png";
import img3 from "@/assets/explore-maatra/remote-family-img3-new.png";
import { useS3VideoUrl } from "@/hooks/useS3VideoUrl";
import {
  VIDEO_FAMILY_TAB_S3_FILE,
  VIDEO_EMERGENCY_CARD_S3_FILE,
  VIDEO_REMINDER_S3_FILE,
} from "@/utils/constants";

import ExploreScreen, { ExploreCard } from "./ExploreScreen";

const BEIGE =
  "radial-gradient(ellipse at center, rgba(236,221,184,1) 0%, rgba(245,235,225,1) 100%)";
const PINK =
  "radial-gradient(ellipse at center, rgba(245,182,231,1) 0%, rgba(244,215,233,1) 100%)";
const PURPLE =
  "radial-gradient(ellipse at center, rgba(209,193,237,1) 0%, rgba(242,225,245,1) 100%)";

const RemoteFamily: React.FC = () => {
  const { t } = useTranslation();

  const familyTabVideoUrl = useS3VideoUrl(VIDEO_FAMILY_TAB_S3_FILE);
  const emergencyCardVideoUrl = useS3VideoUrl(VIDEO_EMERGENCY_CARD_S3_FILE);
  const reminderVideoUrl = useS3VideoUrl(VIDEO_REMINDER_S3_FILE);

  const cards: [ExploreCard, ExploreCard, ExploreCard] = [
    {
      img: img1,
      title: t("auth.remoteFamily.cards.c1"),
      thumbGradient: PINK,
      videoUrl: familyTabVideoUrl,
      imgStyle: { width: "100%", height: "100%", left: "0px", top: "0px" },
    },
    {
      img: img2,
      title: t("auth.remoteFamily.cards.c2"),
      thumbGradient: PURPLE,
      videoUrl: emergencyCardVideoUrl,
      imgStyle: { width: "100%", height: "100%", left: "0px", top: "0px" },
    },
    {
      img: img3,
      title: t("auth.remoteFamily.cards.c3"),
      thumbGradient: PURPLE,
      videoUrl: reminderVideoUrl,
      imgStyle: {
        width: "100%",
        height: "100%",
        left: "0px",
        top: "0px",
        objectPosition: "50% 91.7%",
      },
    },
  ];

  return (
    <ExploreScreen
      pill={t("auth.remoteFamily.pill")}
      bodyText={t("auth.remoteFamily.bodyText")}
      cards={cards}
    />
  );
};

export default RemoteFamily;
